import React from "react";
import type { Payload } from "recharts/types/component/DefaultLegendContent";
import { StudentsBarChartProps } from "./types";

interface CustomLegendProps {
  payload?: Payload[];
  chartConfig: StudentsBarChartProps["chartConfig"];
}

export const Legend = ({ payload, chartConfig }: CustomLegendProps) => {
  return (
    <div className="flex justify-end gap-6 pr-5 text-foreground">
      {payload?.map((entry, index) => {
        const { color, legend } = chartConfig[entry.value] || {};
        return (
          <div key={`legend-item-${index}`} className="flex items-center gap-2">
            <span
              className="h-1 w-5 rounded-full"
              style={{ backgroundColor: color }}
            />
            <span>{legend}</span>
          </div>
        );
      })}
    </div>
  );
};
